export const MAX_SELECTED_CITIES = 10;

export const POSTER_COLORS = [
    {id: 'paper', main: '#ffffff', text: '#000000'},
    {id: 'ink', main: '#000000', text: '#ffffff'},
    {id: 'pine', main: '#344e41', text: '#ffffff'},
    {id: 'mint', main: '#acd0c6', text: '#000000'},
    {id: 'deepSea', main: '#08426f', text: '#ffffff'},
    {id: 'amber', main: '#ffd380', text: '#000000'},
    {id: 'blush', main: '#fa90aa', text: '#000000'},
    {id: 'plum', main: '#413f60', text: '#ffffff'},
    {id: 'coral', main: '#e87659', text: '#000000'},
];
